/**
 * useProCalculatorMutations Hook
 *
 * GraphQL mutation operations for ProCalculator
 * Handles saving calculations to the backend
 */

import type { ProCalculatorFormValues, ProCalculatorResults } from '../../../types/proCalculator';
import {
  saveProCalculationForCurrentYear,
  getSavedProCalculationByYear,
} from '../../../lib/api/savedProCalculationApi';

/**
 * useProCalculatorMutations Hook
 *
 * Provides mutation operations for saving and loading calculations
 */
export function useProCalculatorMutations() {
  /**
   * Save professional calculation for current year
   * Creates or updates the saved calculation
   */
  const saveCalculation = async (
    formValues: ProCalculatorFormValues,
    results: ProCalculatorResults
  ): Promise<void> => {
    await saveProCalculationForCurrentYear(formValues, results);
  };

  /**
   * Load saved professional calculation by year
   */
  const loadCalculation = async (userId: string, year: number) => {
    return await getSavedProCalculationByYear(userId, year);
  };

  return {
    saveCalculation,
    loadCalculation,
  };
}
